export default __webpack_public_path__ + "static/sticker_2-139dfdcc9d5faa0dd9c1bceab0ca103f.png";